$(document).ready( function(){
  let num_of_products_on_page = document.querySelectorAll(".collection-item");
  let current_products = document.querySelector(".current-products");
  let bar = document.querySelector(".load-more-bar div");
  filter.init();

  /* find on click, keydown, hover events in here */
  addEventListeners();

  stickyHeader();
  toggleDualSlideshowPopup();
  setNumberOfProducts(num_of_products_on_page, current_products);
  if(bar != undefined || bar != undefined){
    loadMoreBar(bar);
  }
  removeHyphens();
  fakeSelect.init();
  productTabs.init();
  updateCartFieldsOnCartPage.init();
  megaMenu.init();
  /* convert insta feed text to html */
  waitForElement("#insta-feed", function(){
    $("#insta-feed h2").append('<a href="https://www.instagram.com/rudehealth/"> @rudehealth</a>')
  });

});

const waitForElement = (elementPath, callBack) => {
  window.setTimeout(function(){
    if($(elementPath).length){
      callBack(elementPath, $(elementPath));
    }else{
      waitForElement(elementPath, callBack);
    }
  },500)
}

const megaMenu = {
  init(){
    this.mega_menu_list_elements = $("#header ul li");
    this.mega_menu = document.querySelectorAll("#header .mega-menu");
    this.addEventListeners();
  },
  addEventListeners(){
    /* mega menu 1 */
    if(this.mega_menu_list_elements != undefined || this.mega_menu_list_elements != null){
      /* desktop */
      if($(window).width() >= 950){
        this.mega_menu_list_elements.each(function(){
          let mega_menu = $(this).parents(".desktop-menu").find(".mega-menu");
          // mouse over
          $(this).mouseover(function(){
            let dataTitle = $(this).data("title");
            mega_menu.each(function(){
              if($(this).data("mega") == dataTitle){
                $(this).addClass("active");
                $(this).mouseover(function(){
                  $(this).addClass("active");
                });
              }
            });
          });
          // mouse out
          $(this).mouseout(function(){
            let dataTitle = $(this).data("title");
            mega_menu.each(function(){
              if($(this).data("mega") == dataTitle){
                $(this).removeClass("active");
                $(this).mouseout(function(){
                  $(this).removeClass("active");
                });
              }
            });
          });
        });
      } else {
        /* mobile */
        this.mega_menu_list_elements.each(function(){
          let mega_menu = $(this).parents("#mobile-menu").find(".mega-menu");
          let cross = $(this).find(".mobile_header_cross");
          $(this).siblings("li").removeClass("active");
          $(this).on("click", function(){
            let dataTitle = $(this).data("title");
            mega_menu.each(function(){
              if($(this).data("mega") == dataTitle){
                mega_menu.removeClass("active"); 
                cross.parents("li").siblings("li").find(".mobile_header_cross").removeClass("active");
                if(cross.hasClass("active")){
                  $(this).removeClass("active");
                  cross.removeClass("active");
                } else {
                  $(this).addClass("active");
                  cross.addClass("active");
                }
              }
            });
          });
        });
      }
    }
  }
}
const updateCartFieldsOnCartPage = {
  init(){
    this.cartQuantityFields = document.querySelectorAll(".cart_page_quantity_inputs");
    this.addEventListeners();
  },
  updateField(qty, variantId){
    let data = {id: variantId, quantity: qty};
    setTimeout(function(){
      $.ajax({
        url: "/cart/change.js",
        dataType: "json",
        type: "POST",
        data: data,
        success: function(){
          window.location.reload();
        }
      });
    }, 1000);
  },
  addEventListeners(){
    if(this.cartQuantityFields != undefined || this.cartQuantityFields != null){
      this.cartQuantityFields.forEach(cartField => {
        cartField.onchange = () => {
          let cartFieldId = cartField.dataset.id;
          let cartFieldQty = cartField.value;
          this.updateField(cartFieldQty, cartFieldId);
        }
      });
    }
  }
}
/* product tabs functionality */
const productTabs = {
  init(){
    this.product_tabs = document.querySelectorAll(".product-tabs-container div");
    this.product_content = document.querySelectorAll(".product-content-container");
    this.showFirstTab();
    this.addEventListeners();
  },
  showFirstTab(){
    if(this.product_content[2] != undefined || this.product_content[2] != null){
      this.product_content[2].classList.add("active");
    }
  },
  showTab(product_tab){
    let contentData;
    this.product_content.forEach(content => {
      contentData = content.dataset.content;
      if(product_tab.dataset.tab == contentData){
        content.classList.add("active");
      } else {
        content.classList.remove("active");
      }
    });
  },
  addEventListeners(){
    if(this.product_tabs != undefined || this.product_tabs != null){
      this.product_tabs.forEach(tab => {
        tab.addEventListener("click", () => {
          this.showTab(tab);
        },{passive: false});
      });
    }
  }
}

  /* select functionality */
  const fakeSelect = {
    init(){
      this.fakeSelectors = document.querySelectorAll(".fakeSelect");
      this.variantsContainer = document.querySelector(".variants-container");
      this.arrow = document.querySelector(".fake-selector-svg");
      this.product_select = document.querySelector("#productSelect");
      this.addToCartButton = document.querySelector(".AddToCart");
      this.addEventListeners();
    },
    addEventListeners(){
      if(this.fakeSelectors != undefined || this.fakeSelectors != null){
        this.fakeSelectors.forEach(fakeSelector => {
          let openVariants = fakeSelector.querySelector(".openSelect");
          let variantsContainer = fakeSelector.querySelector(".variants-container");
          let variants = variantsContainer.querySelectorAll("p");

          variants.forEach(variant => {
            variant.addEventListener("click", () => {
              this.variantOnClick(variant);
              this.closeVariants();
              /* update variant info */
              this.updateVariantInfo(variant);
              if(variant.querySelector(".price").innerHTML.toLowerCase() == "sold out"){
                this.disableATCButton();
              } else {
                this.enableATCButton();
              }
            },{passive: false});
          });
          openVariants.addEventListener("click", () => {
            if(this.variantsContainer.classList.contains("open")){
              this.closeVariants();
            } else {
              this.openVariants(variantsContainer);
            }
          },{passive: false});
          this.variantHover(variants);
        });
      }
    },
    updateVariantInfo(variant_value){
      let variant_id = variant_value.dataset.id;
      this.product_select.value = variant_id;
      this.product_select.dispatchEvent(new Event("change"));
    },
    disableATCButton(){
      this.addToCartButton.disabled = true;
      this.addToCartButton.classList.add("disabled");
    },
    enableATCButton(){
      this.addToCartButton.disabled = false;
      this.addToCartButton.classList.remove("disabled");
    },
    openVariants(variantsContainer){
      variantsContainer.classList.add("open");
      this.arrow.classList.add("active-arrow");
    },
    closeVariants(){
      if(this.variantsContainer != null || this.variantsContainer != undefined){
        this.variantsContainer.classList.remove("open");
        this.arrow.classList.remove("active-arrow");
      }
    },
    variantHover(variants){
      variants.forEach(variant => {
        variant.addEventListener("mouseover", () => {
          variant.classList.add("active");
        },{passive: false});
        variant.addEventListener("mouseout", () => {
          variant.classList.remove("active");
        },{passive: false});
      });
    },
    variantOnClick(variant){
      let title = variant.querySelector(".title").innerHTML;
      let price = variant.querySelector(".price").innerHTML;
      let updatedTitle = document.querySelector(".variant-change-title");
      let updatedPrice = document.querySelector(".variant-change-money");
      let variant_selector_title = document.querySelector(".variant_picker_title");

      if(updatedTitle != null || updatedTitle != undefined){
        variant_selector_title.innerHTML = title;
        updatedTitle.innerHTML = title;
        variant_selector_title = title;
      }
      if(updatedPrice != null || updatedPrice != undefined){
        updatedPrice.innerHTML = price;
      }
    }
  }

const removeHyphens = () => {
  setTimeout( () => {
    let text = document.querySelectorAll(".hyphen-text");
  
    text.forEach(a =>{
      if(a !== undefined || a !== null){
        a.innerHTML = a.innerHTML.split("-").join(" ");
      }
    });
  }, 700);

}
/* add event listeners */
const addEventListeners = () => {
  let bar = document.querySelector(".load-more-bar div");
  /* load more collection items */
  let loadMoreButton = document.querySelector(".load-more-collection-items button");
  if(loadMoreButton != undefined || loadMoreButton != null){
    loadMoreButton.addEventListener("click", () => {
      loadMore(loadMoreButton, ".products-on-page", ".collection-item", ".current-products");
      setTimeout(function(){
        loadMoreBar(bar);
      },1000);
    },{passive: false});
  }
  let loadMoreBlogsButton = document.querySelector(".load-more-blog-items button");
  if(loadMoreBlogsButton != undefined || loadMoreBlogsButton != null){
    loadMoreBlogsButton.addEventListener("click", () => {
      loadMore(loadMoreBlogsButton, ".blog-posts-on-page", ".blog_post");
      removeHyphens();
    },{passive: false});
  }
  /* open hamburger menu */
  let hamburger_menu = document.querySelector("#hamburger-menu");
  let mobile_menu = document.querySelector("#mobile-menu");
  hamburger_menu.addEventListener("click", function(){
    if(mobile_menu.classList.contains("show_menu")){
      mobile_menu.classList.remove("show_menu");
    } else {
      mobile_menu.classList.add("show_menu");
    }
  },{passive: false});
}
/* load more bar (collection page) */
const loadMoreBar = (bar) => {
  let collectionItemsContainer = document.querySelector(".load-more-collection-items");
  let currentProducts = collectionItemsContainer.querySelector(".current-products").innerHTML;
  let totalProducts = collectionItemsContainer.querySelector(".total-products").innerHTML;
  let calculation = Math.floor((currentProducts / totalProducts) * 100);
  if(bar != null || bar != undefined){
    bar.style.width = calculation + "%";
  }
}
/* add sticky header styles */
const stickyHeader = () => {
  let header = document.querySelector("#header");
  let bodyContent = document.querySelector(".body-content");
  let sticky = header.offsetTop;
  window.onscroll = function(){
    if(window.pageYOffset > sticky){
      header.classList.add("sticky");
      bodyContent.classList.add("paddingTop");
    } else {
      header.classList.remove("sticky");
      bodyContent.classList.remove("paddingTop");
    }
  }
}


/* toggle dual slideshow popups */
const toggleDualSlideshowPopup = () => {
  let slides = document.querySelectorAll("#twoSlideSplide .splide__slide");
  if(slides != undefined || slides != null){
    slides.forEach(slide => {
      let popup = slide.querySelector(".dual_slideshow_popup");
      slide.addEventListener("mouseover", () => {
        if(popup != undefined || popup != null){
          popup.classList.add("show_popup");
        }
      },{passive: false});
      slide.addEventListener("mouseout", () => {
        if(popup != undefined || popup != null){
          popup.classList.remove("show_popup");
        }
      },{passive: false});
    });
  }
}
const loadMore = (load_more_btn, container, items, current_items) => {
  let products_on_page = document.querySelector(container);
  let next_url = products_on_page.dataset.nextUrl;
  let num_of_products_on_page = document.querySelectorAll(items);
  let current_products = document.querySelector(current_items);
  
  if(products_on_page != null || products_on_page != undefined){
    $.ajax({
      url: next_url,
      type: "GET",
      dataType: "html",
      beforeSend: function(){
        load_more_btn.style.display = "none";
      }
    }).done(function(next_page){
      let new_products = $(next_page).find(container);
      let new_url = new_products.data("next-url");

      if(new_url){
        load_more_btn.style.display = "flex";
      }
      products_on_page.dataset.nextUrl = new_url;   
      products_on_page.innerHTML += new_products[0].innerHTML;
      num_of_products_on_page = document.querySelectorAll(items);
      if(current_products != null || current_products != undefined){
        setNumberOfProducts(num_of_products_on_page, current_products);
      }
    }); 
  }
}
/* set number of products remaining (collection page) */
const setNumberOfProducts = (numOfProducts, element) => {  
  if(element != undefined || element != null){
    element.innerHTML = numOfProducts.length;
  }
}



